import React, {useEffect,useState,useContext} from 'react'
import Divider from '@mui/material/Divider';
import { AlertDialog } from '../MUI/AlertDialog';
import { MuiAccordion } from '../MUI/Accordion';
import {Button,Grid,Card,CardContent,Box} from "@material-ui/core";
import {Formik} from 'formik';
import { makeStyles } from "@material-ui/core/styles";
import { DropzoneArea } from "material-ui-dropzone";
import {useAlumno} from '../../Context/alumnoContext'
import Axios from 'axios';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const useStyle = makeStyles({
    selectpais: {
        background:'gray',
        color:'black'
    },
    selectprovincia: {
        background: 'gray',
        color:'black'
    },
  });
//                                            <InfoOutlinedIcon sx={{ fontSize: 25,color:'yellow' }} /> 

export const SubirArchivo = ({texto,titulo,file,setFile,tiposFiles,maximo,opcional})=>{
    const classes = useStyle();
    const [dataFile, setDataFile] = React.useState('');
    //const [file, setFile] = React.useState();
    const {snackbar} = useAlumno()

    const onImageDrop = async (e) => {
//        setDataFile(e[0]);
        console.log(e[0])
        setFile(e[0]);
      }
    
      const onImageChange = (event) => {
        try {
          setFile(event[0]);
          console.log(event[0])
        } catch (error) {
        }
      };

      const subirArchivo = async (values)=>{
        try{
            if (!file){
                snackbar.showMessage("Por favor selecciona un archivo", "error");
            }else{
                
                await doPostFile(file)
                setFile(null)
            }
        }catch(err){
            snackbar.showMessage(err.message, "error");
        }
           
      }

      const doPostFile = async (file) => {

        let form = new FormData()
         form.append('upload', file, file.name);
        
         const uploadFile = await loadDataload(form);

       }

       const loadDataload = async (form) => {
        try {
            const respuesta = await Axios.post(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/upload`,form,{headers: { 'Content-Type': 'multipart/form-data' }})
            console.log('respuesta',respuesta)
            return respuesta.data;
        } catch (error) {
          return error;
        }
      };

return <React.Fragment>
    <Grid
        //justify="space-between" // Add it here :)
        container
        style={{fontSize:'large'}}
        className='flex justify-center mt-[20px] p-0 mb-3'
        direction="row"
      >
        <Grid item className='w-full max-w-full'>
            <Box className='flex items-center justify-center border-solid border-[1px] border-white rounded-md'>
                <p className='w-full m-auto text-center text-[14px] font-semibold'>{titulo} <span className={opcional ? '':'c-obl'}></span></p> 
                {/*file && <CheckBoxIcon sx={{ fontSize: 30,color:'green' }}/>*/}
                {/*!file && <CheckBoxOutlineBlankIcon sx={{ fontSize: 30,color:'red' }}/>*/}
                {/*file && <p>{file.path}</p>*/}
                {file && false && <DeleteIcon sx={{ fontSize: 30 }}/>}
            </Box>
            {file && <Box className='flex items-center mb-[30px]'>
                    <AttachFileIcon sx={{ fontSize: 30 }}/>
                    <span 
                        className="text-xs font-medium truncate" 
                        style={{ opacity: 1, display: 'block', width: '100%' }}
                        title={file.path} // Esto permite ver el nombre completo al pasar el mouse
                    >
                        {file.path}
                    </span>
                    <Button startIcon={<DeleteIcon/>} title="Eliminar el archivo adjunto" onClick={()=>setFile(null)}></Button>
                </Box>}
        </Grid>
      </Grid>
      {!file && <Grid
        //justify="space-between" // Add it here :)
        container
        className='flex justify-center'
        direction="row"
      >

            <Grid item>
                    <Formik
                    initialValues={{ "dato": "" }}
                    enableReinitialize={true}
                    /* validate={validate} */
                    onSubmit={subirArchivo}
                    >

                    {props => {
                        const {
                        values,
                        touched,
                        errors,
                        status,
                        isSubmitting,
                        validate,
                        handleChange,
                        handleSubmit,
                        handleBlur
                        } = props;

                        return (<form className={classes.form} onSubmit={handleSubmit}>
                                <Card className="flex justify-center !bg-[#DEDEDE] mb-3">
                                        <CardContent>
                                            <DropzoneArea
                                                onChange={onImageChange}
                                                dropzoneText={texto}
                                                acceptedFiles={tiposFiles || ['.pdf']}
                                                filesLimit={1}
                                                showFileNames
                                                maxFileSize={maximo}
                                                getDropRejectMessage={() => 'El tamaño del archivo supera el máximo permitido'}
                                                getFileAddedMessage={() => 'Se seleccionó un archivo para adjuntar'}
                                                getFileRemovedMessage={() => 'Se eliminó el archivo'}
                                                alertSnackbarProps={{
                                                    autoHideDuration: 3000,
                                                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                }}
                                            />
                                        </CardContent>
                                        {/*<CardActions>
                                        <Button type="submit" className={classes.submit} color="primary" variant="contained">
                                            Subir archivo
                                        </Button>

                                        <Button color="primary" onClick={() => { alert(25); }}>
                                            Cancelar
                                        </Button>
                                        </CardActions>*/}
                                </Card>
                                <p className='color-red'>Máximo: {textoMaximo(maximo)}</p>
                            </form>)
                            
                        }
                    }
                </Formik>
            </Grid>
      </Grid>}


          </React.Fragment>
    
    } 

const textoMaximo = (maximo)=>{
    if(maximo>=1000000){
        return `${maximo/1000000} Mb`
    }else{
        return `${maximo/1000} Kb`
    }
}